import { FC } from "react";

import { ConfirmationBar } from "./ConfirmationBar";

interface ISkipLandingPageTestConfirmationBannerProps {
  flowSlug: string;
  currentSectionIndex: number;
}

export const EXPECTED_FLOW_SLUG = "sign-up-flow";
export const EXPECTED_SECTION_INDEX = 0;

export const SkipLandingPageTestConfirmationBanner: FC<ISkipLandingPageTestConfirmationBannerProps> = (
  { flowSlug, currentSectionIndex },
) => (
  <>
    { (flowSlug === EXPECTED_FLOW_SLUG && currentSectionIndex === EXPECTED_SECTION_INDEX) ? (
      <ConfirmationBar icon="tickHeavy">Great news! 20% discount applied.</ConfirmationBar>
    ) : null }
  </>
);
